import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';

import { useTranslation } from 'react-i18next';
import styles from './VerificationBannerForEmployerProfile.module.css';

function VerificationBannerForEmployerProfile({ title, desc1, buttonTitle, }) {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.titleWrapper}>
                <p className={styles.bannerHeading}>{title}</p>
                {desc1 &&
                    <div>
                        <p className={styles.bannerDesc}>{desc1}</p>
                    </div>
                }
            </div>
            <BubbleButton
                to={{ pathname: "/profile/billing", search:'pricing' }}
                headerButton>{buttonTitle}</BubbleButton>
        </div >
    );
}

export default VerificationBannerForEmployerProfile;
